import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const VerifyEmailPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await axios.get(`/api/verify-email/${token}/`);
        const { message, status, access, refresh } = response.data;

        setMessage(message);
        setStatus(status);

        if (status === "success") {
          // Store tokens in localStorage
          localStorage.setItem("access_token", access);
          localStorage.setItem("refresh_token", refresh);
        }
      } catch (error) {
        setMessage(error.response?.data?.message || "An error occurred.");
        setStatus("error");
      }
    };

    verifyEmail();
  }, [token]);

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-gray-100 dark:bg-gray-900">
      <h1 className={`text-3xl font-bold mb-6 ${status === "success" ? "text-green-500" : "text-red-500"}`}>
        {message}
      </h1>
      {status === "success" && (
        <>
          <button
            onClick={() => navigate("/user")}
            className="mt-4 px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none"
          >
            Go to User Page
          </button>
          <button
            onClick={() => navigate("/")}
            className="mt-4 px-6 py-2 bg-gray-700 text-white rounded-md hover:bg-gray-800 focus:outline-none"
          >
            Go to Homepage
          </button>
        </>
      )}
      {status === "error" && (
        <button
          onClick={() => navigate("/")}
          className="mt-4 px-6 py-2 bg-gray-700 text-white rounded-md hover:bg-gray-800 focus:outline-none"
        >
          Go to Homepage
        </button>
      )}
    </div>
  );
};

export default VerifyEmailPage;
